import { motion } from "framer-motion";
import { CHAPTERS } from "../lib/brand";
import { useT } from "../lib/i18n";

export default function Manifesto() {
  const { t } = useT();
  return (
    <section
      id="tours"
      className="bg-[color:var(--bg-elev)] py-20 md:py-28 relative overflow-hidden"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 mb-12 md:mb-16">
          <div className="md:col-span-4">
            <p className="overline mb-3">{t("manifesto.overline")}</p>
            <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
              {t("manifesto.headingLine1")}
              <br /> {t("manifesto.headingLine2")}
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7">
            <p className="text-base md:text-lg text-white/70 leading-relaxed">
              {t("manifesto.subhead")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-y-2">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.04 }}
              className="col-span-12 grid grid-cols-12 gap-3 md:gap-6 items-start py-6 md:py-8 border-t border-white/15 group"
              data-testid={`chapter-${c.n}`}
            >
              <div className="col-span-2 md:col-span-2">
                <span className="font-mono text-[color:var(--primary)] text-2xl md:text-3xl group-hover:text-white transition-colors duration-500">
                  {c.n}
                </span>
              </div>
              <div className="col-span-10 md:col-span-6">
                <h3 className="font-display text-white text-2xl md:text-3xl lg:text-4xl leading-[0.95]">
                  {t(`manifesto.chapters.${c.n}.title`, c.title)}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-4">
                <p className="text-sm md:text-base text-white/60 leading-relaxed">
                  {t(`manifesto.chapters.${c.n}.body`, c.body)}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
